import React, { Fragment } from 'react';
import './Manage.scss'
import HrbTranslate from '../../../../components/language/HrbTranslate';
import ContentPlain from '../../../../components/layout/ContentPlain';
import HelpLink from '../../../../components/library/common/HelpLink';
import AssignAgentPane from './AssignAgentPane';

const ManageTicket = (props) => {
    const { isClosed, officeId, associateId } = props;

    return (
        <Fragment>
            <ContentPlain elementId='manage-ticket-description'>
                <div className='columns manage-ticket'>
                    <div className='column is-8 is-offset-1'>
                        <div>
                            <h3><HrbTranslate text='ManageTicket.Title' /></h3>
                            <HrbTranslate text='ManageTicket.Description' className='p1' />
                        </div>
                    </div>
                    <div className='column is-2 pt-4'>
                        <HelpLink helpKey='0ProSupport/VDOPro/ManagingTicket.htm' />
                    </div>
                </div>
            </ContentPlain>
            <AssignAgentPane isClosedTicket={isClosed} officeId={officeId} associateId={associateId}/>
        </Fragment>
    )
}

ManageTicket.whyDidYouRender = false;

export default ManageTicket